import { FunctionComponent } from 'react';

import styles from './NotificationBanner.module.sass';

export interface NotificationBannerProps {
    once?: boolean; // todo Not implemented yet
    text?: string;
    closeIcon?: boolean;
}

const NotificationBanner: FunctionComponent<NotificationBannerProps> = ({
    once = false,
    closeIcon = false,
    text,
    children,
}) => {
    return (
        <div className={styles.container}>
            {text ? <div className={styles.message}>{text}</div> : children}
            {closeIcon ? <span className={styles.closeItIcon} /> : null}
        </div>
    );
};

export default NotificationBanner;
